<template>
  <div class="peSign">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @search-change="searchChange"
        @search-reset="searchReset"
        :search.sync="search"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
        <template slot="menuLeft" slot-scope="{ size }">
          <el-button
            type="primary"
            :size="size"
            icon="el-icon-circle-plus-outline"
            @click="openAddDialog('', 'add')"
          >
            新增
          </el-button>
        </template>
        <template slot="search" slot-scope="scope">
          <div class="d-f align-c m-r-10">
            <span class="w-120 m-r-10 c-606266">译员ID/昵称:</span>
            <el-input
              v-model="search.trId"
              placeholder="请输入译员ID/昵称"
            ></el-input>
          </div>
        </template>
        <template slot="industry" slot-scope="scope">
          <span v-for="item in scope.row.industryList" :key="item.fieldId">
            {{ item.fieldName }}
          </span>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="openAddDialog(scope.row, 'edit')"
          >
            编辑
          </el-button>
          <el-button type="text" size="mini" @click="deleteSign(scope.row)">
            删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 新增签约 -->
    <el-dialog :visible.sync="dialogAdd" @close="closeDialog" :title="addTitle">
      <div class="d-f m-b-20" v-if="dialogType == 'add'">
        <el-input
          class="w-250 m-r-20"
          v-model="searchId"
          placeholder="请输入译员ID/昵称"
          clearable
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="searchTrans('add')"
        >
          搜索
        </el-button>
      </div>
      <el-form
        label-position="right"
        label-width="80px"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item label="译员ID" prop="trId">
          <el-input v-model="ruleForm.trId" disabled></el-input>
        </el-form-item>
        <el-form-item label="译员昵称" prop="nickName">
          <el-input v-model="ruleForm.nickName" disabled></el-input>
        </el-form-item>
        <el-form-item label="签约领域" prop="signIndustry">
          <el-checkbox-group v-model="ruleForm.signIndustry">
            <el-checkbox
              v-for="item in industryList"
              :key="item.fieldId"
              :label="item.fieldId"
            >
              {{ item.fieldName }}
              <span v-if="item.isHot == 1">（爆品）</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSign">确 定</el-button>
        <el-button @click="dialogAdd = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  pagePeSign,
  saveOrUpdateSignTr,
  getPeSign,
} from '@/api/resource/peSign';
import { industry, getAllEnableField } from '@/api/qc/manage';
import { statistics } from '@/api/dot/flow';
import { tableOption } from '@/const/crud/resource/peSign';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'practice',
  data() {
    return {
      form: {},
      search: {
        trId: null,
      },
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      tableLoading: false,
      tableOption: tableOption,
      staParams: null,
      dialogAdd: false,
      industryList: [],
      ruleForm: {
        trId: null,
        nickName: null,
        signIndustry: [],
      },
      rules: {
        trId: [{ required: true, message: '请补充译员ID', trigger: 'blur' }],
        nickName: [
          { required: true, message: '请补充译员昵称', trigger: 'blur' },
        ],
        signIndustry: [
          {
            type: 'array',
            required: true,
            message: '请选择签约领域',
            trigger: 'change',
          },
        ],
      },
      searchId: null, //新增、修改时用来查询的译员ID
      addTitle: null,
      dialogType: null,
      currentRow: null,
    };
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },

  created() {},

  mounted() {
    this.getIndustryList();
    this.getList(this.page, this.search);
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '签约PE管理',
    };
    this.statistics();
  },

  methods: {
    // 获取领域列表
    getIndustryList() {
      getAllEnableField({}).then((res) => {
        this.industryList = res.data?.data;
      });
    },

    // 获取签约PE列表
    getList(page, params) {
      this.tableLoading = true;
      pagePeSign(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
          },
          params,
        ),
      ).then((res) => {
        this.tableData = res?.data?.data?.records || [];
        this.page.total = res?.data?.data?.total;
        this.tableLoading = false;
      });
    },

    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 删除签约
    deleteSign(row) {
      this.$confirm('确定删除签约?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          saveOrUpdateSignTr({
            trId: row.trId,
            operaFlag: 3,
          }).then((res) => {
            this.$refs.crud.searchReset();
            this.getList(this.page);
            this.$message.success('删除成功');
          });
        })
        .catch(() => {});
    },

    // 单个查询签约译员
    searchTrans(type, row) {
      getPeSign({
        trId: type == 'add' ? this.searchId : row.trId,
        operaFlag: type == 'add' ? 1 : 2,
      }).then((res) => {
        if (res.data?.data) {
          this.ruleForm.trId = res.data?.data?.trId;
          this.ruleForm.nickName = res.data?.data?.nickName;
          let industry = res.data?.data?.industryList;
          if (type == 'edit' && industry.length) {
            let ids = industry.map((item) => {
              return item.fieldId;
            });
            this.ruleForm.signIndustry = ids;
          }
        } else {
          this.$message.warning('轻任务系统查无此译员');
          this.ruleForm.trId = null;
          this.ruleForm.nickName = null;
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '单个搜索译员',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    closeDialog() {
      this.searchId = null;
      this.ruleForm.trId = null;
      this.ruleForm.nickName = null;
      this.ruleForm.signIndustry = [];
    },

    // 新增签约译员
    addSign() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          saveOrUpdateSignTr({
            trId:
              this.dialogType == 'add' ? this.searchId : this.currentRow.trId,
            industryCode: this.ruleForm.signIndustry.join(','),
            operaFlag: this.dialogType == 'add' ? 1 : 2,
          }).then((res) => {
            this.dialogAdd = false;
            let msg = this.dialogType == 'add' ? '新增成功' : '修改成功';
            this.$message.success(msg);
            this.$refs.crud.searchReset();
            this.getList(this.page);
          });
        } else {
          return false;
        }
      });
    },

    // 打开编辑框
    openAddDialog(row, type) {
      this.dialogType = type;
      this.currentRow = row;
      if (type == 'edit') {
        this.searchTrans(type, row);
      }
      this.addTitle = type == 'add' ? '新增签约PE' : '编辑签约PE';
      this.dialogAdd = true;
    },

    searchChange(form, done) {
      this.search = form;
      this.page.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form, this.search);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList(this.page, this.search);
    },

    currentChange(current) {
      this.page.currentPage = current;
      this.getList(this.page, this.search);
    },
  },
};
</script>

<style lang="scss" scoped></style>
